import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client } from "../client";

export const useLarkWebhookClients = (merchantId: string) => {
  return useQuery({
    queryKey: ["admin", "lark-webhook-clients", merchantId],
    queryFn: async () => {
      const res = await client.admin["lark-webhook-clients"][":merchantId"].$get({
        param: { merchantId },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};
